import {ReactNode, useEffect} from 'react';
import useTypedDispatch from '../../../../../../common/useTypedDispatch';
import useTypedSelector from '../../../../../../common/useTypedSelector';
import {Loading} from '../../../../../../design-system/atoms/Loading/Loading';
import {ViewerInfo} from '../../../../../../graphql/generated/types';
import {events} from '../constant/textViewerSagaEvents';
import {
  clearCurrentProgress,
  clearTextViewerError,
} from '../state/textViewerSlice';

export function TextViewerFetcherHeadless({
  seriesId,
  productId,
  children,
  viewerInfoData,
}: {
  seriesId: number;
  productId: number;
  children: ReactNode;
  viewerInfoData: ViewerInfo;
}) {
  const {isDataLoaded, currentHtmlInfo, currentChapterId, error} =
    useTypedSelector(state => ({
      isDataLoaded: state.textViewer.viewData[productId]?.isDataLoaded || false,
      currentHtmlInfo: state.textViewer.viewData[productId]?.currentHtmlInfo,
      currentChapterId: state.textViewer.viewData[productId]?.currentChapterId,
      error: state.textViewer.viewData[productId]?.error,
    }));
  const dispatch = useTypedDispatch();

  useEffect(() => {
    dispatch(events.textViewerEntered({seriesId, productId, viewerInfoData}));
    return () => {
      // 현재 회차 뷰어 이탈 시 page 및 챕터 정보를 초기화합니다.
      dispatch(clearCurrentProgress({productId}));
    };
  }, [dispatch, productId, seriesId]);

  useEffect(() => {
    dispatch(events.currentChapterChanged({productId}));
  }, [dispatch, productId, currentChapterId]);

  useEffect(() => {
    if (error) {
      throw error;
    }
    return () => {
      dispatch(clearTextViewerError({productId}));
    };
  }, [dispatch, error, productId]);

  return currentHtmlInfo || isDataLoaded ? (
    <>{children}</>
  ) : (
    <div className="flex-center-full">
      <Loading />
    </div>
  );
}
